import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { memo, useState } from "react";
import { useDebounce } from "use-debounce";
import { StringSelect } from "~/components/StringSelect";
import { usePublicCameraModelsList } from "~/swr-hooks/filters/usePublicCameraModelsList";
export const PublicCameraModelsSelect = /*#__PURE__*/ memo((param)=>{
    let { boardId, make, ...props } = param;
    const { shortId } = useShortIdContext();
    const [searchValue, setSearchValue] = useState("");
    const [debouncedSearchValue] = useDebounce(searchValue, 200, {
        trailing: true
    });
    const { data = [], isLoading } = usePublicCameraModelsList({
        search: debouncedSearchValue,
        shortId,
        boardId,
        make
    });
    return /*#__PURE__*/ _jsx(StringSelect, {
        id: "camera-model",
        placeholder: "Search for model",
        isLoading: isLoading,
        values: data,
        onInputChange: setSearchValue,
        ...props
    });
});
PublicCameraModelsSelect.displayName = "PublicCameraModelsSelect";
